import {observer} from 'mobx-react-lite'
import CompanyEdit from '../../CompanyEdit'
import clubStore from '../../../storage/ClubStore'
import {useEffect} from 'react'
import {useLocation} from 'react-router-dom'

const EditCompany = () => {
  const location = useLocation()
  useEffect(() => {
    if (clubStore.club.id) {
      clubStore.club_edit.getForEdit(clubStore.club.id)
    }
  }, [location.pathname])
  return <CompanyEdit company={clubStore.club_edit} redirect={'/manager/company/info'}/>
};

export default observer(EditCompany)